var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "subtitle-1 black--text mt-2" },
    [
      _vm.itemsExist
        ? [
            _vm._l(_vm.firstThreeItems, function (item, i) {
              return _c(
                "span",
                {
                  key: i,
                  staticClass:
                    "mb-1 inline-flex items-center mr-2 rounded-full text-xs font-medium leading-4 border border-grey-800 text-gray-800 transition duration-300",
                  class: `${
                    _vm.linked ? "hover:border-primary-500 cursor-pointer" : ""
                  } ${_vm.avatar ? "pl-1 pr-2 py-0.5" : "px-2 py-1"}`,
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.redirect(item.id)
                    },
                  },
                },
                [
                  _vm.avatar
                    ? _c("card-chip-avatar", {
                        staticClass: "mr-1",
                        attrs: { avatar: item.avatar },
                      })
                    : _vm._e(),
                  typeof item === "object"
                    ? [_vm._v(_vm._s(item.name))]
                    : [_vm._v(_vm._s(item))],
                ],
                2
              )
            }),
            _vm.itemsMoreThanLimit && !_vm.showAll
              ? _c(
                  "span",
                  {
                    staticClass:
                      "mb-1 inline-flex items-center mr-2 px-2.5 py-1 rounded-full text-xs font-medium leading-4 border border-grey-800 text-gray-800",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.expand.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.items.length - _vm.limit) + " more")]
                )
              : _vm._e(),
            _vm.items.length === _vm.limit && _vm.items.length > 3
              ? _c(
                  "span",
                  {
                    staticClass:
                      "flex items-center justify-center transition duration-100 bg-gray-200 rounded-full w-7 h-7 text-gray-600 text-xs mx-0.5 mb-1 cursor-pointer hover:bg-red-400 hover:text-white",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.collapse.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-3 h-3",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : [
            _c(
              "span",
              {
                staticClass:
                  "mb-1 inline-flex items-center mr-2 px-2.5 py-1 rounded-full text-xs font-medium leading-4 text-gray-400 bg-gray-100",
              },
              [_vm._v("-")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }